export default {
  init() {
    if (!jQuery('#cartModal').length) return

    jQuery(document).on('click', '.zd-cart-plus, .zd-cart-minus', e => {
      this.updateQuantity(e.target)
    })

  },
  updateQuantity(target) {
    const $input = jQuery(target).siblings('.quantity:first').find('input.qty')

    if (!$input.length) return

    const item_quantity = parseInt($input.val())
    const step = parseInt($input.attr('step') || 1)
    const amount = jQuery(target).is('.zd-cart-plus') ? (item_quantity + step) : (item_quantity - step)

    if (item_quantity <= 0) return
    $input.val(amount)

    var item_hash = $input.attr( 'name' ).replace(/cart\[([\w]+)\]\[qty\]/g, '$1')
    const itemData = {
      target,
      _original_value: item_quantity,
      _current_value: amount,
    }

    this.ajaxUpdateCart(item_hash, amount, itemData)
  },
  ajaxUpdateCart(item_hash, amount, itemData) {
    /*global woocommerce_params */
    const $modal = jQuery('#cartModal');
    const $modalContent = jQuery('#cartModal').find('.modal-content:first');
    $modal.find('button, input').prop('disabled', true);
    if ($modalContent.length) $modalContent.addClass('zd-mini-cart__overlay')

      $.ajax({
          type: 'POST',
          url: woocommerce_params.ajax_url,
          data: {
              action: 'qty_cart',
              hash: item_hash,
              quantity: amount,
          },
          success: () => {
            jQuery(document.body).trigger('wc_fragment_refresh');
            this.triggerGtmEvent(itemData)
            jQuery(document.body).one('wc_fragments_refreshed', () => {
              if ($modalContent.length) $modalContent.removeClass('zd-mini-cart__overlay')
              $modal.find('button, input').prop('disabled', false);
            })
          },
          fail: () => {
            if ($modalContent.length) $modalContent.removeClass('zd-mini-cart__overlay')
            $modal.find('button, input').prop('disabled', false);
          },
      });

  },
  triggerGtmEvent({ target, _original_value, _current_value}) {
    /* global gtm4wp_currency, gtm4wp_datalayer_name */
    var productdata = jQuery(target).closest( '.mini_cart_item' ).find( '.remove' );

      if ( _original_value < _current_value ) {
        window[ gtm4wp_datalayer_name ].push({
          'event': 'gtm4wp.addProductToCartEEC',
          'ecommerce': {
            'currencyCode': gtm4wp_currency,
            'add': {
              'products': [{
                'name':       productdata.data( 'gtm4wp_product_name' ),
                'id':         productdata.data( 'gtm4wp_product_id' ),
                'price':      productdata.data( 'gtm4wp_product_price' ),
                'category':   productdata.data( 'gtm4wp_product_cat' ),
                'variant':    productdata.data( 'gtm4wp_product_variant' ),
                'stocklevel': productdata.data( 'gtm4wp_product_stocklevel' ),
                'quantity':   _current_value - _original_value,
              }],
            },
          },
        });
      } else {
        window[ gtm4wp_datalayer_name ].push({
          'event': 'gtm4wp.removeFromCartEEC',
          'ecommerce': {
            'currencyCode': gtm4wp_currency,
            'remove': {
              'products': [{
                'name':       productdata.data( 'gtm4wp_product_name' ),
                'id':         productdata.data( 'gtm4wp_product_id' ),
                'price':      productdata.data( 'gtm4wp_product_price' ),
                'category':   productdata.data( 'gtm4wp_product_cat' ),
                'variant':    productdata.data( 'gtm4wp_product_variant' ),
                'stocklevel': productdata.data( 'gtm4wp_product_stocklevel' ),
                'quantity':   _original_value - _current_value,
              }],
            },
          },
        });
      }

  },
}

// function updateQty(key,qty){
//   url = ‘http://yourdomain.com/updatecart/’;
//   data = “cart_item_key=”+key+”&cart_item_qty=”+qty;

//   jQuery.post( url, data ) .done(function( data ) {
//   //function updateCartFragment
//   updateCartFragment();
//   });
//   }

//   function updateCartFragment() {
//   $fragment_refresh = {
//   url: woocommerce_params.ajax_url,
//   type: ‘POST’,
//   data: { action: ‘woocommerce_get_refreshed_fragments’ },
//   success: function( data ) {
//   if ( data && data.fragments ) {
//   jQuery.each( data.fragments, function( key, value ) {
//   jQuery(key).replaceWith(value);
//   });

//   if ( $supports_html5_storage ) {
//   sessionStorage.setItem( “wc_fragments”, JSON.stringify( data.fragments ) );
//   sessionStorage.setItem( “wc_cart_hash”, data.cart_hash );
//   }
//   jQuery(‘body’).trigger( ‘wc_fragments_refreshed’ );
//   }
//   }
//   };

//   //Always perform fragment refresh
//   jQuery.ajax( $fragment_refresh );
//   }
